// extracted by mini-css-extract-plugin
export default {"carousel-changes":"carousel-changes_yPRNXbQC"};